import {
  errorLoading, loading, loaded, responseHandler, errorGetStatus,
  tokenInterceptor
} from '../manager/HttpManager'
import { clearMediasActions } from './LibraryWS'
import { clearContentsAction } from './ContentWS'
import { fetchLogoutAction } from './AuthWS'
import Constants from '../constants/Constants'

let urlServer = Constants.UrlsConstants.urlServer
let page = 1
let maxPage = 1
let limit = 10
let isFetchingDatas = false

export const appWS = (state = {
  apps: [], userApps: [], app: {}, globalApp: {},
  currentTeam: ''
}, action) => {
  switch (action.type) {
    case Constants.ActionsConstants.APPS.SET_USER_APPS:
      return Object.assign({}, state, { userApps: action.datas })
    case Constants.ActionsConstants.APPS.CLEAR_USER_APPS:
      return Object.assign({}, state, { userApps: [] })
    case Constants.ActionsConstants.APPS.SET_APPS:
      return Object.assign({}, state, { apps: state.apps.concat(action.datas.content) })
    case Constants.ActionsConstants.APPS.CLEAR_APPS:
      return Object.assign({}, state, { apps: [] })
    case Constants.ActionsConstants.APPS.SET_APP:
      action.datas.styles = action.datas.theme.colorStyles.styles
      return Object.assign({}, state, { app: action.datas, globalApp: action.datas })
    case Constants.ActionsConstants.APPS.SET_APP_DETAIL:
      return Object.assign({}, state, { appDetail: action.datas })
    case Constants.ActionsConstants.APPS.SET_CURRENT_TEAM:
      return Object.assign({}, state, { currentTeam: action.datas })
    case Constants.ActionsConstants.APPS.SET_CHILD_APP:
      return Object.assign({}, state, { app: action.datas.children, globalApp: action.datas.allApps })
    case Constants.ActionsConstants.APPS.CLEAR_APP:
      return Object.assign({}, state, { app: {}, globalApp: {} })
    case Constants.ActionsConstants.APPS.SET_APP_DESIGN:
      let newApp = JSON.parse(JSON.stringify(state.app))
      newApp.name = action.datas.name
      newApp.logo = action.datas.logo
      newApp.splashscreen = action.datas.splashscreen
      newApp.iconNotif = action.datas.iconNotif
      newApp.copyright = action.datas.copyright
      newApp.spaceDef = action.datas.spaceDef
      newApp.theme = action.datas.theme
      return Object.assign({}, state, { app: newApp })
    case Constants.ActionsConstants.APPS.SET_APP_DESIGN_COLORS:
      let appColors = JSON.parse(JSON.stringify(state.app))
      if (appColors.theme) {
        appColors.theme.colorStyles.styles = action.datas
      }
      return Object.assign({}, state, { app: appColors })
    case Constants.ActionsConstants.APPS.SET_APP_PARTICIPATION:
      let appParticip = JSON.parse(JSON.stringify(state.app))
      appParticip.forgottenPwdActive = action.datas.forgottenPwdActive
      appParticip.updatePhotoActive = action.datas.updatePhotoActive
      appParticip.blockAccountCreation = action.datas.blockAccountCreation
      appParticip.useBiometric = action.datas.useBiometric
      appParticip.activateAccount = action.datas.activateAccount
      appParticip.accountCreationGroups = action.datas.accountCreationGroups
      appParticip.userInfoVisibility = action.datas.userInfoVisibility
      appParticip.subscriptionType = action.datas.subscriptionType
      appParticip.loginType = action.datas.loginType
      appParticip.smsSenderId = action.datas.smsSenderId
      appParticip.authGamo = action.datas.authGamo
      appParticip.authFacebook = action.datas.authFacebook
      appParticip.authTwitter = action.datas.authTwitter
      appParticip.authAzure = action.datas.authAzure
      appParticip.authWS = action.datas.authWS
      appParticip.azureADConfig = action.datas.azureADConfig
      appParticip.wsConfig = action.datas.wsConfig
      appParticip.profileTemplate = action.datas.profileTemplate
      appParticip.loginExpiration = action.datas.loginExpiration
      appParticip.tokenExpiration = action.datas.tokenExpiration
      return Object.assign({}, state, { app: appParticip })
    case Constants.ActionsConstants.APPS.UPDATE_APP:
      let app = JSON.parse(JSON.stringify(state.app))
      app.locales = action.datas.locales
      app.name = action.datas.name
      app.stores = action.datas.stores
      app.version = action.datas.version
      if (action.datas.mapWizeApiKey) {
        app.mapWizeApiKey = action.datas.mapWizeApiKey
      }
      if (action.datas.mapWizeAccessKey) {
        app.mapWizeAccessKey = action.datas.mapWizeAccessKey
      }
      if (action.datas.subscriptionDef) {
        app.subscriptionDef = action.datas.subscriptionDef
      }
      if (action.datas.hasOwnProperty('showSubscriptionAfterLogin')) {
        app.showSubscriptionAfterLogin = action.datas.showSubscriptionAfterLogin
      }
      return Object.assign({}, state, { app })
    default:
      return state
  }
}

export const setCurrentTeam = (data) => {
  return {
    type: Constants.ActionsConstants.APPS.SET_CURRENT_TEAM,
    datas: data,
  }
}

export const setApps = (data) => {
  return {
    type: Constants.ActionsConstants.APPS.SET_APPS,
    datas: data,
  }
}

export const setUserApps = (data) => {
  return {
    type: Constants.ActionsConstants.APPS.SET_USER_APPS,
    datas: data,
  }
}

export const clearUserApps = (data) => {
  return {
    type: Constants.ActionsConstants.APPS.CLEAR_USER_APPS,
    datas: data,
  }
}

export const setApp = (data) => {
  console.log(data)
  return {
    type: Constants.ActionsConstants.APPS.SET_APP,
    datas: data,
  }
}

export const setAppDetail = (data) => {
  return {
    type: Constants.ActionsConstants.APPS.SET_APP_DETAIL,
    datas: data,
  }
}

export const upApp = (data) => {
  return {
    type: Constants.ActionsConstants.APPS.UPDATE_APP,
    datas: data,
  }
}

export const setAppDesign = (data) => {
  return {
    type: Constants.ActionsConstants.APPS.SET_APP_DESIGN,
    datas: data,
  }
}

export const setAppDesignColors = (data) => {
  return {
    type: Constants.ActionsConstants.APPS.SET_APP_DESIGN_COLORS,
    datas: data,
  }
}

export const setAppParticipation = (data) => {
  return {
    type: Constants.ActionsConstants.APPS.SET_APP_PARTICIPATION,
    datas: data,
  }
}

export const setChildApp = (data) => {
  return {
    type: Constants.ActionsConstants.APPS.SET_CHILD_APP,
    datas: data,
  }
}
export async function fetchAllTeamsApps(teams) {
  let apps = []
  for (const user of teams) {
    try {
      let userApps = await (fetch(`${urlServer}app/list?owner=${encodeURIComponent(user.owner)}&page=1&size=10000&sort=creation&dir=DESC`, {
        method: 'GET',
        headers: Constants.UrlsConstants.header,
      }).then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
        .then(r => r.json())
      )
      apps = [...apps, ...userApps.content]
    } catch (err) {
      console.log(err)
    }
  }
  return apps
}
export function fetchAppsAction(dispatch, application = null, allApps = null, user = null, teamOwner = null,
  appid = null, identifier = null) {
  function refreshApp() {
    if (appid) {
      let entryPoint = Constants.UrlsConstants.appsEntryPoint
      let method = Constants.MethodsWSConstants.APPS.FETCH_APPS
      // TODO: better to fetch
      let url = urlServer + entryPoint + method + '?page=1&size=10000&sort=creation&dir=DESC'

      if (teamOwner) {
        url = url + '&owner=' + encodeURIComponent(teamOwner)
      }

      fetch(url, {
        method: 'GET',
        headers: Constants.UrlsConstants.header,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          if (data.content) {
            let app
            data.content.forEach((currentApp) => {
              if (currentApp.id === appid) {
                app = currentApp
              }
            })
            if (app) {
              dispatch(setApp(app))
            }
          }
        })
        .catch(error => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          }
        })
    }
  }

  function fetchApps(loadedMessage) {
    dispatch(setCurrentTeam(teamOwner))

    if (page <= maxPage && !isFetchingDatas) {
      dispatch(loading(''))
      isFetchingDatas = true
      let entryPoint = Constants.UrlsConstants.appsEntryPoint
      let method = Constants.MethodsWSConstants.APPS.FETCH_APPS
      let url = urlServer + entryPoint + method + '?page=' + page + '&size=' + limit + '&sort=creation&dir=DESC'

      if (teamOwner) {
        url = url + '&owner=' + encodeURIComponent(teamOwner)
      }

      if (page <= maxPage) {
        fetch(url, {
          method: 'GET',
          headers: Constants.UrlsConstants.header,
        })
          .then(response => {
            tokenInterceptor(response)
            return responseHandler(response)
          })
          .then(r => r.json())
          .then(data => {
            maxPage = data.totalPages
            if (maxPage >= page) page++
            isFetchingDatas = false
            dispatch(setApps(data))
            if (loadedMessage) {
              dispatch(loaded(loadedMessage))
            } else {
              dispatch(loaded(''))
            }
          })
          .catch(error => {
            if (errorGetStatus(error) === 401) {
              dispatch(errorLoading('Error.Croutons.authExpired'))
              fetchLogoutAction(dispatch).fetchLogout()
            }
          })
      }
    }
  }

  function fetchOwnerApps() {
    let entryPoint = Constants.UrlsConstants.appsEntryPoint
    let method = Constants.MethodsWSConstants.APPS.FETCH_OWNER_APPS
    fetch(urlServer + entryPoint + method + '?owner=' + encodeURIComponent(user), {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setUserApps(data))
      })
  }

  function fetchAppDetail() {
    // build url
    let entryPoint = Constants.UrlsConstants.appsEntryPoint
    let method = Constants.MethodsWSConstants.APPS.DETAIL_APP
    let queryParams = appid + '/' + identifier

    fetch(urlServer + entryPoint + method + queryParams, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setAppDetail(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function setAppDesignInStore() {
    dispatch(setAppDesign(application))
  }

  function setAppDesignColorsInStore() {
    dispatch(setAppDesignColors(application))
  }

  function setAppParticipationInStore() {
    dispatch(setAppParticipation(application))
  }

  function setAppInStore() {
    dispatch(setApp(application))
    refreshLastAccess()
  }

  function setChildAppInStore() {
    dispatch(setChildApp({
      children: application,
      allApps: allApps,
    }))
    refreshLastAccess()
  }

  function refreshLastAccess() {
    let entryPoint = Constants.UrlsConstants.appsEntryPoint
    let method = Constants.MethodsWSConstants.APPS.UPDATE_APP + 'APPLICATION_ACCESS'
    fetch(urlServer + entryPoint + method, {
      method: 'PUT',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify({
        id: application.id,
        lastAccess: new Date().getTime(),
      }),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {

      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  return {
    refreshApp,
    fetchApps,
    fetchOwnerApps,
    fetchAppDetail,
    setAppInStore,
    setAppDesignInStore,
    setAppDesignColorsInStore,
    setAppParticipationInStore,
    setChildAppInStore,
  }
}

export const clearApps = () => {
  page = 1
  maxPage = 1
  limit = 10
  return {
    type: Constants.ActionsConstants.APPS.CLEAR_APPS,
    datas: null,
  }
}

export const clearApp = () => {
  return {
    type: Constants.ActionsConstants.APPS.CLEAR_APP,
    datas: null,
  }
}

export function clearAppsFromStoreAction(dispatch) {
  function clearAppsFromStore() {
    dispatch(clearApps())
    clearMediasActions(dispatch).clearMediasFromStore()
  }

  function clearAppFromStore() {
    dispatch(clearApp())
    clearMediasActions(dispatch).clearMediasFromStore()
    clearContentsAction(dispatch).clrContents()
  }

  function clearUserAppsFromStore() {
    dispatch(clearUserApps())
  }

  return {
    clearAppsFromStore,
    clearAppFromStore,
    clearUserAppsFromStore,
  }
}

export function saveAppActions(dispatch, application, appId, identifier, userMail, refreshApp, syncId) {
  function createApp() {
    let entryPoint = Constants.UrlsConstants.appsEntryPoint
    let method = Constants.MethodsWSConstants.APPS.ADD_APP
    if (appId) {
      method = Constants.MethodsWSConstants.APPS.COPY_APP + appId
    }
    dispatch(loading(''))
    fetch(urlServer + entryPoint + method, {
      method: 'POST',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(application),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(clearApps())
        fetchAppsAction(dispatch, null, null, null, userMail).fetchApps('Error.Croutons.saveSuccess')
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function updateApp() {
    let entryPoint = Constants.UrlsConstants.appsEntryPoint
    let method = Constants.MethodsWSConstants.APPS.UPDATE_APP + 'APPLICATION_UPDATE'
    dispatch(loading(''))
    fetch(urlServer + entryPoint + method, {
      method: 'PUT',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(application),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(clearApps())
        fetchAppsAction(dispatch).fetchApps('Error.Croutons.saveSuccess')
        if (refreshApp) {
          dispatch(upApp(data))
        }
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function updateAppDetail() {
    let entryPoint = Constants.UrlsConstants.appsEntryPoint
    let method = Constants.MethodsWSConstants.APPS.UPDATE_APP + identifier
    dispatch(loading(''))
    fetch(urlServer + entryPoint + method, {
      method: 'PUT',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(application),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        dispatch(setAppDetail(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function duplicateApp() {
    let entryPoint = Constants.UrlsConstants.appsEntryPoint
    let method = Constants.MethodsWSConstants.APPS.DUP_APP + application.id
    dispatch(loading(''))
    fetch(urlServer + entryPoint + method, {
      method: 'POST',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify({ version: application.version }),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(clearApps())
        fetchAppsAction(dispatch).fetchApps('Error.Croutons.saveSuccess')
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function deleteApp() {
    let entryPoint = Constants.UrlsConstants.appsEntryPoint
    dispatch(loading(''))
    fetch(urlServer + entryPoint + appId, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(clearApps())
        fetchAppsAction(dispatch).fetchApps('Error.Croutons.saveSuccess')
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function syncApp() {
    let entryPoint = Constants.UrlsConstants.appsEntryPoint + 'sync/'
    fetch(urlServer + entryPoint + appId, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.syncSuccess'))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function syncDatasource() {
    let entryPoint = Constants.UrlsConstants.appsEntryPoint + 'sync/datasource/'
    fetch(urlServer + entryPoint + appId + '/' + identifier + '/' + syncId, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.syncSuccess'))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  return {
    createApp,
    updateApp,
    updateAppDetail,
    duplicateApp,
    deleteApp,
    syncApp,
    syncDatasource,
  }
}
